import { Component } from '@angular/core';
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { TextareaComponent } from "@shared/controls/textarea/textarea.component";
import { ReactiveFormsModule } from "@angular/forms";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { RouterLink } from "@angular/router";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { IPartialHeaderData } from "../../../../shared/services/header.service";
import { BaseBulkSendForSigningComponent } from "../base-bulk-send-for-signing/base-bulk-send-for-signing.component";
import {
  ListGridClientSideComponent
} from "@shared/components/grid/components/list-grid-client-side/list-grid-client-side.component";

@Component({
  selector: 'app-bulk-send-documents-for-signing',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    DividerComponent,
    LoaderComponent,
    CheckboxComponent,
    TextareaComponent,
    ListGridClientSideComponent,
  ],
  templateUrl: 'bulk-send-documents-for-signing-page.component.html',
  styleUrl: '../../styles/bulk-send-for-signing.scss'
})
export class BulkSendDocumentsForSigningPageComponent extends BaseBulkSendForSigningComponent {
  override readonly headerData: IPartialHeaderData = {
    title: 'Bulk Send Documents for Signing',
    subtitle: 'Please enter the signatories contact details',
    iconClass: 'ic-bulk-changes-20'
  };
}
